/* global angular */

var ngModule = angular.module('trends');

ngModule.service('Usage', ['Api',
    function (Api) {
        this.log = function(event_type, args) {
            Api.usage[event_type].post(args);
        };
    }
]);

ngModule.directive('homepageUsage', ['Usage', 'TagManager',
    function (Usage, TagManager) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope) {
                var logView = function (name) {
                    Usage.log('viewpage', {
                        page: 'homepage',
                        extra: name 
                    });

                    TagManager.pageView('/homepage/' + name);
                };

                scope.$watch('selectedTab', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        logView(newValue);
                    }
                });

                // Log initial page load
                if (scope.selectedTab) {
                    logView(scope.selectedTab);
                }
            }
        };
    }
]);
